var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5661 11.4999H22.0595V9.12879C22.0595 4.74328 18.5793 1.07981 14.2295 1.0016C14.1106 0.999466 13.8731 0.999466 13.7543 1.0016C9.4044 1.07981 5.92425 4.74328 5.92425 9.12879V11.4999H5.41759C4.63684 11.4999 4 12.3055 4 13.3005V25.1929C4 26.1868 4.63684 27 5.41764 27H22.5661C23.3469 27 23.9838 26.1868 23.9838 25.1929V13.3005C23.9838 12.3056 23.3469 11.4999 22.5661 11.4999ZM15.5985 19.2347V22.8281C15.5985 23.2396 15.254 23.5878 14.8422 23.5878H13.1417C12.7298 23.5878 12.3854 23.2396 12.3854 22.8281V19.2347C11.986 18.8415 11.7534 18.2979 11.7534 17.6965C11.7534 16.5569 12.6343 15.5777 13.7544 15.5324C13.8731 15.5276 14.1108 15.5276 14.2295 15.5324C15.3496 15.5777 16.2305 16.5569 16.2305 17.6965C16.2304 18.2979 15.9979 18.8415 15.5985 19.2347ZM18.7204 11.4999H14.2295H13.7543H9.26343V9.12879C9.26343 6.51641 11.3864 4.35637 13.9919 4.35637C16.5973 4.35637 18.7204 6.51641 18.7204 9.12879V11.4999H18.7204Z",
    fill: "#2A323F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.1a9bb0447c27f2c1d644cd4e4fa562a5.svg";
export { ForwardRef as ReactComponent };